var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"threeDimensional"},[_c('div',{staticClass:"content"},[_c('ul',{staticClass:"ul"},_vm._l((_vm.imgList),function(item,index){return _c('li',{key:index,staticClass:"li"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":item.img,"alt":""}}),_c('div',{staticClass:"layer"},[_vm._v(" "+_vm._s(item.desc)+" ")])])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }